import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';
import { Props as PhasePerformanceChartProps } from 'components/widgets/PhasePerformanceChart/PhasePerformanceChart';

export const phasePerformanceChart: IHashmapItemWithCustomProps<PhasePerformanceChartProps> = {
    titleWithoutProjectAndContract: 'Phase Performance',
    NoPermissionMessage,
    permission: 'PortfolioPage',
    reportStyle: {
        widgetSizesAvailable: { large: LARGE, extraLarge: EXTRA_LARGE },
        widgetInitialSize: LARGE,
    },
};
